import { ELocalStorageKey } from '../types/enums'
import request, { IWorkspaceResponse } from '/@/api/http/request'
import { mapLayers } from '/@/constants/mock-layers'
import { elementGroupsReq, PostElementsBody, PutElementsBody,ListForm } from '/@/types/mapLayer'
const PREFIX = '/map/api/v1'
const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
type UnknownResponse = Promise<IWorkspaceResponse<unknown>>
// get elements group
// export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
//   const url = `${PREFIX}/workspaces/${workspace_id}/element_groups`
//   const result = await request.get(url, {
//     params: {
//       group_id: reqParams.groupId,
//       is_distributed: reqParams.isDistributed
//     },
//   })
//   return result.data
// }
export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
  return mapLayers
}

// Get elements groups request
export const getElementGroupsReq = async (body: elementGroupsReq): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/` + workspace_id + '/element-groups'
  const result = await request.get(url, body)
  return result.data
}
// add element
export const postElementsReq = async (pid: string, body: PostElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${pid}/elements`
  const result = await request.post(url, body)
  return result.data
}
// Update map element request
export const updateElementsReq = async (id: string, body: PutElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/` + workspace_id + `/elements/${id}`
  const result = await request.put(url, body)
  return result.data
}
// Delete map element
export const deleteElementReq = async (id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/` + workspace_id + `/elements/${id}`
  const result = await request.delete(url, body)
  return result.data
}

// Delete layer elements
export const deleteLayerEleReq = async (id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/` + workspace_id + `/element-groups/${id}/elements`
  const result = await request.delete(url, body)
  return result.data
}

//预警列表
export const getWarningList = async (body: ListForm): Promise<any> => {
  const url = `/shipping/event/list`
  const result = await request.post(url, body)
  return result.data
}

//新增预警列表
export const addWarningList = async (body: any): Promise<any> => {
  const url = `/system/event/add`
  const result = await request.post(url, body)
  return result.data
}

//航标获取
export const getnavigationMarkList = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/navigationMark/list`
  const result = await request.post(url, body)
  return result.data
}

//航标新增
export const addNavigationMarkList = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/navigationMark/add`
  const result = await request.post(url, body)
  return result.data
}

//航标修改
export const modifyNavigationMarkList = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/navigationMark/modify`
  const result = await request.post(url, body)
  return result.data
}

//航标删除
export const deleteNavigationMarkList = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/navigationMark/delete`
  const result = await request.post(url, body)
  return result.data
}

//航标图片上传
export const uploadNavigationMark = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/navigationMark/upload`
  const result = await request.post(url, body)
  return result.data
}

//船标获取
export const getShipInfoMarkList = async (body: any): Promise<any> => {
  const url = `/manage/api/v1/shipInfo/list`
  const result = await request.post(url, body)
  return result.data
}

//日志列表
export const getlogList = async (device_sn:any,domain_list:any,body: any): Promise<any> => {
  const url = `/manage/api/v1/workspaces/` + workspace_id + `/devices/${device_sn}/logs?domain_list=` + domain_list
  const result = await request.get(url, body)
  return result.data
}

export const setlogList = async (device_sn:any,body: any): Promise<any> => {
  const url = `/manage/api/v1/workspaces/` + workspace_id + `/devices/${device_sn}/logs`
  const result = await request.post(url, body)
  return result.data
}